"use strict";

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countryCodes = void 0;

var ISO_3166_1_alpha_2_codes_1 = require("./ISO_3166_1_alpha_2_codes");

var ISO_3166_1_alpha_2_frenchDROMCodes_1 = require("./ISO_3166_1_alpha_2_frenchDROMCodes");

var ISO_3166_1_alpha_2_unsupportedCodes_1 = require("./ISO_3166_1_alpha_2_unsupportedCodes");

exports.countryCodes = ISO_3166_1_alpha_2_codes_1.ISO_3166_1_alpha_2_codes.filter(function (countryCode) {
  return ![].concat(_toConsumableArray(ISO_3166_1_alpha_2_frenchDROMCodes_1.ISO_3166_1_alpha_2_frenchDROMCodes), _toConsumableArray(ISO_3166_1_alpha_2_unsupportedCodes_1.ISO_3166_1_alpha_2_unsupportedCodes)).includes(countryCode);
});